window.addEventListener('DOMContentLoaded', (event) => {
    // let myModal = document.getElementById('myModal')
    const equipmentEle = document.getElementById("modal-equipment-detail");
    if (equipmentEle) {
        let equipmentID = null
        let category = null
        let postType = null
        const equipmentModal = new bootstrap.Modal(equipmentEle, {})
        equipmentEle.addEventListener('shown.bs.modal', () => {
            $.ajax({
                type: "post",
                dataType: 'json',
                async: false,
                url: "/wp-admin/admin-ajax.php",
                data: {
                    action: "getEquipment",
                    id: equipmentID,
                    category: category,
                    postType: postType
                },
                beforeSend: function () {

                },
                success: function (response) {
                   $(equipmentEle).find('.modal-content').html(response.html)
                },
                error: function (jqXHR, textStatus, errorThrown) {
                }
            })
        })
        $(".equipment-image").on('click', function (event) {
            event.preventDefault();
            $target = $(this)
            equipmentID = $target.data('equipment')
            category = $target.data('category')
            if (category) {
                $(equipmentEle).find('.modal-content').html('読み込んでいます...')
                postType = $target.data('post-type')
                equipmentModal.show()
            }
        })
    }


    /*
        $(".equipment-image").click(function (event) {
            event.preventDefault();

        });
        $(".btn-close").click(function () {
            $("#modal-detail").empty()
        });*/
})